/**
 * Created by andrey on 23.04.18.
 */

const DailyTasks = function () {
    this.onChangeStateListener = function () {};
    this.onTaskSwappedOut = function () {};

    this.tasks = [];
    this.whenStart = -1;

    this.load();

    cleverapps.whenAllInitialized(this.update.bind(this));
    cleverapps.user.on("recheckAvailable", this.update.bind(this));

    cleverapps.abExperiments.whenGroupsUpdated(this.update.bind(this));

    cleverapps.eventBus.on("mapEvent", this.onMapEvent.bind(this));
    cleverapps.eventBus.on("taskEvent", this.onTaskEvent.bind(this));
};

DailyTasks.prototype.getInfo = function () {
    return {
        whenStart: this.whenStart,
        tasks: this.tasks.map((task) => task.getSaveInfo())
    };
};

DailyTasks.prototype.reset = function () {
    this.tasks = [];
    this.whenStart = -1;
    this.save();
};

DailyTasks.prototype.load = function (serverData) {
    const data = serverData || cleverapps.dataLoader.load(DataLoader.TYPES.DAILY_TASKS) || {};
    this.tasks = [];
    this.whenStart = data.whenStart !== undefined ? data.whenStart : -1;

    if (this.whenStart > this.getStartTime()) {
        this.whenStart = this.getStartTime();
    }

    const SHOULD_HAVE = 6;
    if (data.tasks && data.tasks.length === SHOULD_HAVE && data.tasks.every((taskData) => DailyTasks.CONFIG[taskData.type])) {
        this.tasks = data.tasks.map((taskData, slot) => {
            const task = new DailyTask();
            task.load(taskData, slot);
            return task;
        });
    } else {
        this.whenStart = -1;
    }
};

DailyTasks.prototype.save = function (updateServer) {
    cleverapps.dataLoader.save(DataLoader.TYPES.DAILY_TASKS, this.getInfo());

    if (updateServer !== false) {
        connector.synchronizer.addSendTask("dailytasks");
    }
};

DailyTasks.prototype.collect = function (task) {
    if (task.collected) {
        return;
    }

    cleverapps.playSession.logEvent(cleverapps.EVENTS.DAILY_TASK_REWARD + (task.difficulty || 3));

    task.collect();
    cleverapps.activities.send(Activities.TYPES.DAILY_TASK, {
        userName: cleverapps.user.getPlayerInfo().name
    });
};

DailyTasks.prototype.collectLastTask = function () {
    const lastTask = cleverapps.dailyTasks.getCompleteAllTask();
    if (lastTask.progress === lastTask.goal && !lastTask.collected && cleverapps.dailyTasks.getNotCollectedTasks().length === 1) {
        lastTask.givePrize();
    }
};

DailyTasks.prototype.pick5Pack = function () {
    const easy = PseudoRandom.GET().chooseN(this.listTaskByDifficulty(DailyTask.EASY).slice(), 2);
    const medium = PseudoRandom.GET().chooseN(this.listTaskByDifficulty(DailyTask.MEDIUM).slice(), 2);
    const hard = PseudoRandom.GET().chooseN(this.listTaskByDifficulty(DailyTask.HARD).slice(), 1);

    const res = easy.concat(medium).concat(hard);
    res.push(DailyTask.CreateCompleteAll());

    return res.map((config) => new DailyTask.Create(config));
};

if (cleverapps.config.debugMode) {
    DailyTasks.GuessName = function (id) {
        return Object.keys(DailyTasks).find((name) => DailyTasks[name] === id);
    };
}

DailyTasks.prototype.listTaskByDifficulty = function (difficulty) {
    if (!this._generatedTasks) {
        this._generatedTasks = this.generateAllTasks();
    }

    return this._generatedTasks[difficulty];
};

DailyTasks.prototype.generateAllTasks = function () {
    const doNotCreate = [DailyTasks.COMPLETE_ALL];

    const res = [[], [], []];

    Object.keys(DailyTasks.CONFIG).forEach((type) => {
        const id = +type;

        if (doNotCreate.indexOf(id) !== -1) {
            return false;
        }

        let config = DailyTasks.CONFIG[id].generate();

        if (config === undefined) {
            return;
        }

        if (!Array.isArray(config)) {
            config = [config];
        }

        config.forEach((config) => {
            config.type = id;
            res[config.difficulty].push(config);
        });
    });

    return res;
};

DailyTasks.prototype.getStartTime = function () {
    const date = new Date();
    const timezone = date.getTimezoneOffset() * 1000 * 60;
    return date.getTime() - (date.getTime() - timezone) % DailyTasks.INTERVAL;
};

DailyTasks.prototype.startNewTasks = function () {
    this.tasks = this.pick5Pack();
    this.whenStart = this.getStartTime();
    this.save();

    cleverapps.playSession.logEvent(cleverapps.EVENTS.DAILY_TASKS_START);
};

DailyTasks.prototype.getNotCollectedTasks = function () {
    return this.tasks.filter((task) => task.isFinished() && !task.collected);
};

DailyTasks.prototype.isAllTasksFinished = function () {
    return cleverapps.dailyTasks.getActiveTasks().length === 0;
};

DailyTasks.prototype.getActiveTasks = function () {
    return this.tasks.filter((task) => !task.isFinished());
};

DailyTasks.prototype.getFinishedTasks = function () {
    return this.tasks.filter((task) => task.isFinished());
};
 
DailyTasks.prototype.swapOutTask = function (taskToSwap, suggested) {
    const targetSlot = this.tasks.indexOf(taskToSwap);

    if (!suggested) {
        const configs = this.listTaskByDifficulty(taskToSwap.difficulty);

        const currentTasks = this.tasks.map((task) => task.type);

        let candidates = configs.filter((config) => currentTasks.indexOf(config.type) === -1);

        if (!candidates.length) {
            const allTasks = cleverapps.dailyTasks.generateAllTasks().flat();
            candidates = allTasks.filter((config) => !this.tasks.find((task) => task.type === config.type && task.difficulty === config.difficulty));

            if (!candidates.length) {
                candidates = allTasks.filter((task) => task.type !== taskToSwap.type);
                cleverapps.throwAsync("Insufficient number of daily tasks!");
            }
        }

        suggested = PseudoRandom.GET().choose(candidates);
    }

    this.tasks[targetSlot] = new DailyTask.Create(suggested);
    this.onTaskSwappedOut(targetSlot);
    this.save();
};

DailyTasks.prototype.addProgress = function (type, amount, options) {
    if (!this.isAvailable()) {
        return;
    }

    let tasks = this.getActiveTasks().filter((activeTask) => activeTask.type === type);
    if (tasks.length === 0) {
        return;
    }
    if (type === DailyTasks.SPEND_HARD) {
        tasks = [tasks[0]];
    }
    tasks.forEach((task) => {
        task.addProgress(amount, options);
    });
};

DailyTasks.prototype.getTimeLeft = function () {
    const duration = DailyTasks.INTERVAL;
    return Math.max(0, this.whenStart + duration - Date.now());
};

DailyTasks.prototype.isAvailable = function (options) {
    if (cleverapps.abExperiments.getGroup(ABExperiments.Tests.weeklyGoalsMatch3) === "A") {
        return false;
    }

    return levels.user.checkAvailable(cleverapps.config.availables.DAILY_TASKS, options);
};

DailyTasks.prototype.beforeUpdate = function () {
    clearTimeout(this.finishTimeout);
};

DailyTasks.prototype.update = function () {
    clearTimeout(this.finishTimeout);

    if (!this.isAvailable()) {
        return;
    }

    cleverapps.playSession.logEventOnce(cleverapps.EVENTS.DAILY_TASK_AVAILABLE);

    if (this.getTimeLeft() === 0) {
        this._generatedTasks = undefined;
        this.startNewTasks();
    }

    this.finishTimeout = new cleverapps.LongTimeout(this.update.bind(this), this.getTimeLeft());

    this.onChangeStateListener();
};

DailyTasks.prototype.getTasks = function () {
    return this.tasks;
};

DailyTasks.prototype.processOpenCard = function (playedCard) {
    if (cleverapps.config.type === "solitaire") {
        this.addProgress(DailyTasks.COLLECT_CARDS_BY_VALUE, 1, {
            cardValue: playedCard.getRank()
        });

        this.addProgress(DailyTasks.COLLECT_CARDS_BY_SUIT, 1, {
            cardSuit: playedCard.getSuit()
        });
    }
};

DailyTasks.prototype.getCompleteAllTask = function () {
    return this.getTasks().filter((task) => task.type === DailyTasks.COMPLETE_ALL)[0];
};

DailyTasks.prototype.taskWasFinished = function (task) {
    cleverapps.playSession.logEvent(cleverapps.EVENTS.DAILY_TASK_FINISH);

    if (task.type !== DailyTasks.COMPLETE_ALL) {
        this.addProgress(DailyTasks.COMPLETE_ALL);
    }

    this.preparePush();
    this.onChangeStateListener();
};

DailyTasks.prototype.preparePush = function () {
    if (this.getFinishedTasks().length < 2) {
        return;
    }

    let timeout;
    if (this.getActiveTasks().length > 0 && this.getTimeLeft() > DailyTasks.PUSH_UNTIL_RESET_TIME) {
        timeout = this.getTimeLeft() - DailyTasks.PUSH_UNTIL_RESET_TIME;
    }

    PushHelper.sendPush(PUSHES.DAILY_TASKS_UNCOMPLETED, timeout);
};

DailyTasks.prototype.onTaskEvent = function (name, amount, options) {
    const type = DailyTasks[name];
    if (type === undefined) {
        return;
    }

    options = typeof amount === "object" ? amount : options;
    amount = typeof amount !== "number" ? 1 : amount;
    cleverapps.dailyTasks.addProgress(type, amount, options);
};

DailyTasks.prototype.onMapEvent = function (type, options) {
    if (cleverapps.config.type === "merge") {
        switch (type) {
            case Map2d.MINE: {
                const data = options.affected.getData();
                if (data.source && data.mineable) {
                    cleverapps.dailyTasks.addProgress(DailyTasks.DESTROY_ENT);
                }
                break;
            }
            case Map2d.COMPLETE_MINING:
                if (options.task && options.task.energy) {
                    cleverapps.dailyTasks.addProgress(DailyTasks.USE_WORKER);
                }
                break;
            case Map2d.BUILD:
                cleverapps.dailyTasks.addProgress(DailyTasks.USE_WORKER);
                cleverapps.dailyTasks.addProgress(DailyTasks.BUILD);
                break;
            case Map2d.MERGE:
                cleverapps.dailyTasks.addProgress(DailyTasks.MERGE, 1, { mergeAmount: options.affected.length });

                if (options.affected.some((unit) => unit.code === "crystal" && unit.isLast())) {
                    cleverapps.dailyTasks.addProgress(DailyTasks.USE_RAINBOW);
                }
                break;
            case Map2d.HARVEST:
                break;
            case Map2d.PRIZE_HARVESTED:
                if (options.affected.getData().chest === true) {
                    cleverapps.dailyTasks.addProgress(DailyTasks.OPEN_CHEST);
                }
                break;
            case Map2d.SPAWN: {
                const spawnCheck = function (spawned, filter) {
                    if (Array.isArray(options.affected)) {
                        const mergeSource = options.affected.filter(filter);
                        if (mergeSource.length > 0) {
                            return spawned.stage > mergeSource[0].stage;
                        }
                    }
                };

                if (options.unit.getType() === cleverapps.unitsLibrary.getExpeditionUnitType("fruit") && options.unit.stage < 4) {
                    if (!options.affected || (!Array.isArray(options.affected)
                        && ["chest", "fruit", "source"].map(cleverapps.unitsLibrary.getExpeditionUnitType)
                            .indexOf(options.affected.getType()) !== -1)) {
                        cleverapps.dailyTasks.addProgress(DailyTasks.GROW_PLANT);
                    }
                } else if (options.unit.getType() === "source") {
                    if (spawnCheck(options.unit, (unit) => unit.getType() === "source")) {
                        cleverapps.dailyTasks.addProgress(DailyTasks.CREATE_SOURCE);
                    }
                } else if (options.unit.code === "wands") {
                    if (spawnCheck(options.unit, (unit) => unit.code === "wands")) {
                        cleverapps.dailyTasks.addProgress(DailyTasks.MERGE_SOLDIERS);
                    }
                } else if (options.affected instanceof Unit) {
                    if (options.affected.getType() === "field" || options.affected.getData().fruit
                        && options.affected.getType() === cleverapps.unitsLibrary.getExpeditionUnitType("fruit")
                        && options.unit.stage === 4) {
                        cleverapps.dailyTasks.addProgress(DailyTasks.HARVEST_FRUITS);
                    }
                }

                break;
            }
            case Map2d.OPENFOG:
                cleverapps.dailyTasks.addProgress(DailyTasks.OPEN_FOG);

                break;
        }
    }
};

DailyTasks.INTERVAL = cleverapps.parseInterval(cleverapps.config.debugMode ? "10 minutes" : "1 day");
DailyTasks.PUSH_UNTIL_RESET_TIME = cleverapps.parseInterval("5 hours");
